import { ThemeEvents } from '@theme/events';

class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdated, this.updateMediaGallery);
  }

  updateMediaGallery = (event) => {
    const newMediaGallery = event.detail?.data?.html?.querySelector('product-media-gallery slider-component');
    const currentMediaGallery = this.querySelector('slider-component');

    if (newMediaGallery && currentMediaGallery && currentMediaGallery.innerHTML !== newMediaGallery.innerHTML) {
      currentMediaGallery.replaceWith(newMediaGallery);
    }

    // Aller à l'image de la variante après que tout soit en place.
    // Pas de requestAnimationFrame ici : le navigateur le met en pause quand la page
    // n'est pas visible/active (onglet en arrière-plan, fenêtre minimisée), ce qui
    // empêchait le slide de bouger alors que le remplacement DOM ci-dessus est déjà
    // synchrone (replaceWith déclenche connectedCallback + montage Splide avant que
    // cette ligne ne s'exécute).
    setTimeout(() => this.goToVariantImage(event), 50);
  };

  goToVariantImage = (event) => {
    const variant = event?.detail?.resource;
    const featuredMedia = variant?.featured_media;

    if (!featuredMedia) return;

    // Splide est 0-indexé, position de Shopify est 1-indexée
    const targetIndex = (featuredMedia.position || 1) - 1;

    // L'instance Splide est sur slider-component.slider (custom property du thème Fullstack)
    const sliderComponent = this.querySelector('slider-component');
    const splideInstance = sliderComponent?.slider;

    if (splideInstance && typeof splideInstance.go === 'function') {
      splideInstance.go(targetIndex);
    }
  };
}

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', ProductMediaGallery);
}